import Script from 'next/script';
import { useState } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { getAppSetting } from '@/domains/core/settings/appSettings';

import { useZendeskConversation } from './hooks/useZendeskConversation';

//iAdvize custom data. For now, we are not using it. We get product details from useDetail hook.
export interface PageCustomData {
  cartAmount?: number;
  categoryId?: number;
  categoryName?: string;
  modelId?: number;
  parentCategoryId?: number;
  productPrice?: number;
  productReference?: string;
  ssrProductPage?: string;
}

export interface ZendeskChatProps {
  pageCustomData?: PageCustomData;
  pageName: string;
  pageType: string;
}

export const ZendeskChat: React.FC<ZendeskChatProps> = ({
  pageType,
  pageName,
}) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  useZendeskConversation(isScriptLoaded, {
    pageType,
    pageName,
  });

  const [useAlternateZendeskKey] = useBooleanFlags(['useAlternateZendeskKey']);
  const ZendeskKey = useAlternateZendeskKey
    ? getAppSetting('EXTERNAL_ALTERNATE_ZENDESK_KEY')
    : getAppSetting('EXTERNAL_ZENDESK_KEY');

  //next script integration: https://nextjs.org/docs/pages/building-your-application/optimizing/scripts
  return (
    <Script
      async
      strategy="lazyOnload"
      crossOrigin="anonymous"
      id="ze-snippet"
      onReady={() => setIsScriptLoaded(true)}
      src={`https://static.zdassets.com/ekr/snippet.js?key=${ZendeskKey}`}
    />
  );
};

ZendeskChat.displayName = 'ZendeskChat';
